export default __webpack_public_path__ + "static/uma-escola-autoral-mobile-b2a4cf684ff82c483143e21ca704b6bb.png";